import { render } from "./Button.vue?vue&type=template&id=798e2bfa&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=798e2bfa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-798e2bfa"

export default script